import i18n from '@shared/i18n/i18n';
import refundsEs from './es/refunds.json';
import refundsEn from './en/refunds.json';

if (!i18n.hasResourceBundle('es', 'refundsModule')) {
  i18n.addResourceBundle('es', 'refundsModule', refundsEs);
}
if (!i18n.hasResourceBundle('en', 'refundsModule')) {
  i18n.addResourceBundle('en', 'refundsModule', refundsEn);
}

export { refundsEs, refundsEn };
